import { CommonModule } from '@angular/common';
import { BaseTitleComponent } from '../base-title/base-title.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admin-secondary-title',
  templateUrl: './secondary-title.component.html',
  styleUrls: ['./secondary-title.component.scss'],
  imports: [CommonModule],
})
export class SecondaryTitleComponent extends BaseTitleComponent implements OnInit {
  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }
}
